import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import UserMenu from "../components/Navbar/UserMenu";
import { useState } from "react";

export default function Navbar({toggleSidebar}) {
      const [rotated, setRotated] = useState(false);
      const handleClick = () => {
    setRotated((prev) => !prev);
    toggleSidebar();
  };
  return (
    <AppBar position="fixed" className="custom-navbar shadow-none" sx={{ bgcolor: "white", color: "black",boxShadow:'none',borderBottom:'1px solid rgba(0, 0, 0, 0.12)' }}>
      <Toolbar>
        <Box className="sidebar-header" sx={{display:'flex',alignItems:'center',gap:1,}}>
            <img src="https://www.logoai.com/oss/icons/2021/12/02/EoLJeYhT6YPfd26.png" alt="logo" width={30} />
            <Typography sx={{color:'#525b75cc', fontSize:20,fontWeight:600,letterSpacing:'-0.04em'}}>Controlpanel</Typography>
        </Box>


        <Box  sx={{ flexGrow: 1 ,ml:3}}>
            <i class="fa-sharp fa-regular fa-arrow-left-long-to-line" onClick={handleClick} style={{color:'#525b75cc',cursor:'pointer'}}></i>
                  {/* <IconButton edge="start" color="inherit"  onClick={handleClick}> */}
          {/* <MenuIcon /> */}
        {/* </IconButton> */}
        </Box>

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}
